module.exports = __webpack_public_path__ + "img/tent-pitches.1093b0b.svg";